import React from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { QuoteProvider } from "./context/QuoteContext";
import theme from "./theme";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Inquiry from "./pages/Inquiry";
import Contact from "./pages/Contact";
import WhatsAppFloat from "./components/WhatsAppFloat";
import CallFloat from "./components/CallFloat";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <QuoteProvider>
          <Router>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/inquiry" element={<Inquiry />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
            <Footer />
            <WhatsAppFloat />
            <CallFloat />
          </Router>
        </QuoteProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
